<div class="ls-page">
  <div class="container-fluid px-2">
    <div class="row g-3">
      <!-- ── MY LEAGUE ─────────────────────────────────────── -->
      <div class="col-12 col-xl-6">
        <div class="ls-panel">
          <!-- panel header -->
          <div class="ls-panel__header">
            <div class="ls-panel__scanlines"></div>
            <div class="d-flex align-items-center gap-2 position-relative" style="z-index: 1">
              <i class="fa fa-user ls-panel__header-icon"></i>
              <span class="ls-panel__title">{{ 'PROFILE.MY_LEAGUE_TITLE' | translate }}</span>
              <a class="ls-master-link ms-auto" routerLink="/admin/gamification/master-league">
                <i class="fa fa-trophy"></i>
                <span class="d-none d-sm-inline">{{ 'PROFILE.MASTER_LEAGUE_LINK' | translate }}</span>
              </a>
            </div>
          </div>

          <!-- tab bar -->
          <div class="ls-tabs d-flex">
            <button
              *ngFor="let tab of tabs; let i = index"
              class="ls-tab"
              [class.ls-tab--active]="selectedLeagueStaticsTab.value === i"
              (click)="selectedLeagueStaticsTab.setValue(i)"
            >
              {{ 'PROFILE.STATISTICS.' + tab + '_TAB_TITLE' | translate }}
            </button>
          </div>

          <!-- leaderboard body -->
          <div class="ls-body">
            <ng-container *ngFor="let tab of tabs; let i = index">
              <div *ngIf="selectedLeagueStaticsTab.value === i">
                <!-- loader -->
                <div *ngIf="leagueStatistics[tab]?.isLoading" class="ls-loader" [@fadeInOut]>
                  <div class="ls-loader__dot"></div>
                  <span class="ls-loader__text">LOADING...</span>
                </div>

                <!-- empty -->
                <div
                  *ngIf="!leagueStatistics[tab]?.items?.length && !leagueStatistics[tab]?.isLoading"
                  class="ls-empty"
                >
                  <i class="fa fa-inbox ls-empty__icon"></i>
                  <span class="ls-empty__text">{{ 'PROFILE.STATISTICS.EMPTY_MESSAGE' | translate }}</span>
                </div>

                <!-- rows -->
                <div [@listFadeInOut]="leagueStatistics[tab]?.items?.length">
                  <div
                    *ngFor="let item of leagueStatistics[tab]?.items; let idx = index; trackBy: trackStatisticsItem"
                    class="ls-row"
                    [class.ls-row--mine]="isMine(item)"
                  >
                    <ng-container *ngTemplateOutlet="rowTpl; context: getContext(item, tab, idx)"></ng-container>
                  </div>
                </div>

                <!-- load more -->
                <div *ngIf="leagueStatistics[tab]?.lastKey" class="ls-load-more">
                  <button class="ls-load-more__btn" (click)="getGamificationStatistics('USER', tab, true)">
                    <i class="fa fa-chevron-down"></i> {{ 'BUTTON.LOAD_MORE' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- ── TEAM LEAGUE ───────────────────────────────────── -->
      <div class="col-12 col-xl-6">
        <div class="ls-panel">
          <div class="ls-panel__header">
            <div class="ls-panel__scanlines"></div>
            <div class="d-flex align-items-center gap-2 position-relative" style="z-index: 1">
              <i class="fa fa-users ls-panel__header-icon"></i>
              <span class="ls-panel__title">{{ 'PROFILE.TEAM_LEAGUE_TITLE' | translate }}</span>
              <a class="ls-master-link ms-auto" routerLink="/admin/gamification/master-league">
                <i class="fa fa-trophy"></i>
                <span class="d-none d-sm-inline">{{ 'PROFILE.MASTER_LEAGUE_LINK' | translate }}</span>
              </a>
            </div>
          </div>

          <div class="ls-tabs d-flex">
            <button
              *ngFor="let tab of tabs; let i = index"
              class="ls-tab"
              [class.ls-tab--active]="selectedTeamStaticsTab.value === i"
              (click)="selectedTeamStaticsTab.setValue(i)"
            >
              {{ 'PROFILE.STATISTICS.' + tab + '_TAB_TITLE' | translate }}
            </button>
          </div>

          <div class="ls-body">
            <ng-container *ngFor="let tab of tabs; let i = index">
              <div *ngIf="selectedTeamStaticsTab.value === i">
                <div *ngIf="teamStatistics[tab]?.isLoading" class="ls-loader" [@fadeInOut]>
                  <div class="ls-loader__dot"></div>
                  <span class="ls-loader__text">LOADING...</span>
                </div>

                <div *ngIf="!teamStatistics[tab]?.items?.length && !teamStatistics[tab]?.isLoading" class="ls-empty">
                  <i class="fa fa-inbox ls-empty__icon"></i>
                  <span class="ls-empty__text">{{ 'PROFILE.STATISTICS.EMPTY_MESSAGE' | translate }}</span>
                </div>

                <div [@listFadeInOut]="teamStatistics[tab]?.items?.length">
                  <div
                    *ngFor="let item of teamStatistics[tab]?.items; let idx = index; trackBy: trackStatisticsItem"
                    class="ls-row"
                    [class.ls-row--mine]="isMine(item)"
                  >
                    <ng-container *ngTemplateOutlet="rowTpl; context: getContext(item, tab, idx)"></ng-container>
                  </div>
                </div>

                <div *ngIf="teamStatistics[tab]?.lastKey" class="ls-load-more">
                  <button class="ls-load-more__btn" (click)="getGamificationStatistics('TEAM', tab, true)">
                    <i class="fa fa-chevron-down"></i> {{ 'BUTTON.LOAD_MORE' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
       ROW TEMPLATE
  ══════════════════════════════════════════ -->
  <ng-template
    #rowTpl
    let-index="index"
    let-type="type"
    let-name="name"
    let-nickname="nickname"
    let-team="team"
    let-image="image"
    let-secondImage="secondImage"
    let-points="points"
    let-prevPoints="prevPoints"
    let-tab="tab"
  >
    <!-- rank badge -->
    <div
      class="ls-row__rank"
      [ngClass]="{
        'ls-row__rank--gold': index === 0,
        'ls-row__rank--silver': index === 1,
        'ls-row__rank--bronze': index === 2
      }"
    >
      <i *ngIf="index === 0" class="fa fa-star"></i>
      <span *ngIf="index !== 0">#{{ index + 1 }}</span>
    </div>

    <!-- avatar (flip card if secondImage) -->
    <div class="ls-row__avatar">
      <div class="ls-flip" *ngIf="secondImage">
        <div class="ls-flip__inner">
          <div class="ls-flip__front">
            <app-s3-image [isRounded]="type === 'USER'" [image]="image" [avatarName]="name"></app-s3-image>
          </div>
          <div class="ls-flip__back">
            <app-s3-image [isRounded]="type === 'USER'" [image]="secondImage" [avatarName]="name"></app-s3-image>
          </div>
        </div>
      </div>
      <div class="ls-flip" *ngIf="!secondImage">
        <app-s3-image [isRounded]="type === 'USER'" [image]="image" [avatarName]="name"></app-s3-image>
      </div>
    </div>

    <!-- team icon -->
    <div class="ls-row__team-icon" *ngIf="type === 'USER' && team?.icon" [matTooltip]="team.name">
      <app-s3-image [image]="team.icon"></app-s3-image>
    </div>

    <!-- name + nickname -->
    <div class="ls-row__identity">
      <span class="ls-row__name">{{ name }}</span>
      <span class="ls-row__nick" *ngIf="nickname">{{ nickname }}</span>
    </div>

    <!-- points + trend -->
    <div class="ls-row__score ms-auto">
      <span class="ls-row__pts">{{ points }}</span>
      <span
        class="ls-row__trend"
        [class.ls-row__trend--up]="prevPoints <= points"
        [class.ls-row__trend--down]="prevPoints > points"
        [matTooltip]="
          points - prevPoints >= 0
            ? 'Up by ' + (points - prevPoints) + ' from last ' + tab
            : 'Down by ' + (prevPoints - points) + ' from last ' + tab
        "
      >
        <i class="fa" [ngClass]="prevPoints > points ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
        <span class="ls-row__trend-val">{{ points - prevPoints >= 0 ? '+' : '' }}{{ points - prevPoints }}</span>
      </span>
    </div>
  </ng-template>
</div>
